import railsUJS from 'rails-ujs';

// Vendor
import 'jquery';
import 'uikit';
import 'owl.carousel';
import 'lightgallery';
import 'slick-carousel';

// Product & POI
import initCarousel from './javascripts/product/carousel';
import initExpandContent from './javascripts/poi/expandContent';

// Shared
import initMobileMenu from './javascripts/mobileMenu';
import initLightGallery from './javascripts/lightGallery';
import initReviewForm from './javascripts/shared/reviewForm';
import IEObjectfitFallback from './javascripts/shared/IEObjectfitFallback';
import initSocialShareButtons from './javascripts/shared/social_share_buttons';
import initBadgeCarousel from './javascripts/poi/badgeCarousel';

// Search
import initSearchBox from './javascripts/searchBox';

// Home
import initSwiper from './javascripts/home/swiper';
import initSearchWidget from './javascripts/home/searchWidget';

// User
import initSelectize from './javascripts/users/selectize';
import avatarPreview from './javascripts/users/avatar_preview';

// Init functions
$(function () {
  initCarousel();
  initExpandContent();
  initMobileMenu();
  initSwiper();
  initSearchWidget();
  initLightGallery();
  initSearchBox();
  initSelectize();
  initReviewForm();
  initSocialShareButtons();
  IEObjectfitFallback();
  avatarPreview();
  initBadgeCarousel();
});

railsUJS.start();



// WEBPACK FOOTER //
// ./app/webpack/packs/application.js